export default {"src":"/_next/static/media/18-icon.8d64ad32.svg","height":46,"width":23,"blurWidth":0,"blurHeight":0};